import React from "react";

import { ExplorePage } from "Pages/Explore/BaseExplorePage";

export const Search: React.FC = () => {
  return <ExplorePage />;
};
